export class Marker {
  lat: number;
  lng: number;
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/+app/shared/map/marker.schema.ts